/**
 * Scrolls to top of the page
 */
export const scrollToTopOfPage = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

/**
 * Runs a callback function when the user presses the 'Enter' key
 *
 * Example usage:
 *
 * <Box sx={containerStyle} tabIndex={0} onKeyDown={(event) => onEnterKeyPress(event, handleNext)}>
 */
export const onEnterKeyPress = (event: React.KeyboardEvent, onEnter: () => void) => {
  if (event.key === 'Enter') {
    onEnter();
  }
};

/**
 * Adds 'https://' to the beginning of a URL if it is missing
 *
 * Example usage:
 *
 * const url = 'example.com';
 * const urlWithHttp = addHttpIfMissing(url);
 */
export const addHttpIfMissing = (url: string) => {
  if (!url.startsWith('http')) {
    return `https://${url}`;
  }

  return url;
};
